<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4">
        <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
          <div class="title-h4">수집서버 목록</div>
          <div>
            <w-header-search-button @click="onToggleCollectorSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <el-row>
          <el-table-wrapper ref="collectorTable" :column-default="columnDefault" :columns="collectorColumns" :data="logCollectors" :pagination="false"
            :show-custom-header="true" :show-search-tool="collectorSearchToolVisible" row-class-name="c-pointer" highlight-current-row @current-change="onChangeCollector">
          </el-table-wrapper>
        </el-row>
      </el-col>
      <el-col :span="20">
        <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
          <div class="title-h4">파일 목록</div>
          <div>
            <w-header-search-button @click="onToggleFileSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <div v-loading="isDownloadLoading" :element-loading-text="loadingMsg">
            <el-table-wrapper v-loading="loading" :column-default="columnDefault" :data="logFiles" :columns="fileColumns" :pagination="true" :show-custom-header="true"
              :show-search-tool="fileSearchToolVisible" ref="logAlarmTable" header-align="center" highlight-current-row @condition-change="onConditionChange">
              <template slot="fileHash-slot" slot-scope="scope">
                <el-button @click="checkFileHash(scope.row)">정합성 검사</el-button>
              </template>
              <template slot-scope="scope" slot="compress-rate-slot">
                {{ getCompressRate(scope.row.compressRate) }}
              </template>
              <template slot-scope="scope" slot="coherence-slot">
                {{ isNil(scope.row.hashChecktime) ? '-' : getDateToString(scope.row.hashChecktime, 'YYYY-MM-DD HH:mm:ss') }}
              </template>
              <template slot-scope="scope" slot="fileName-slot">
                <span v-if="!isEmpty(selectedCollector.ftpFlag) && selectedCollector.ftpFlag !== 'N'" class="link" @click="downloadLogFile(scope.row)">
                  {{ getValueAfterCheckEmpty(`${scope.row.fullPath}`) }}
                </span>
                <span v-else>{{ getValueAfterCheckEmpty(`${scope.row.filePath}/${scope.row.fileName}`) }}</span>
              </template>
              <template slot-scope="scope" slot="regist-datetime-slot">
                {{ getDateToString(scope.row.registDatetime, 'YYYY-MM-DD HH:mm:ss')}}
              </template>
              <template slot-scope="scope" slot="retention-age-slot">
                {{ getValueAfterCheckEmpty(scope.row.retentionAge) }}일
              </template>
              <template slot-scope="scope" slot="hash-flag-slot">
                <w-eventlevel-cell :eventlevel-id="isNil(scope.row.hashIntegrityFlag) ? 'NM' : hashIntegrityFlag[scope.row.hashIntegrityFlag]" type="circle" mini>
                  <span slot="content"></span>
                </w-eventlevel-cell>
              </template>
            </el-table-wrapper>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEmpty, cloneDeep, forEach } from 'lodash';

import LogStoreAPI from '@/api/log/log-store';
import { columnDefault } from '@/constants/table';
import { baseUrl } from '@/config';
import msgUtils from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { convertValuByUnit } from '@/utils/number';
import WEventlevelCell from '@/components/table/EventlevelCell';

const checkRunningStatusTask = 'checkRunningStatusTask';

export default {
  name: 'WLogFileStore',
  components: {
    WEventlevelCell,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      columnDefault,
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      tableParams: {
        start: 0,
        limit: 50,
      },
      logFiles: [],
      logCollectors: [],
      collectorColumns: [
        {
          label: '수집서버명',
          prop: 'logCollectorName',
          searchable: true,
          sortable: true,
        },
        {
          label: 'IP',
          prop: 'logCollectorIpaddress',
          searchable: true,
          sortable: true,
        },
      ],
      fileColumns: [
        {
          label: '파일 경로',
          prop: 'fullPath',
          scopedSlot: 'fileName-slot',
          // searchable: true,
          // sortable: true,
        },
        {
          label: '장비명',
          prop: 'objName',
          searchable: true,
          width: 160,
          // sortable: true,
        },
        {
          label: '용량',
          prop: 'fileSize',
          width: 100,
          formatter: this.getSizeLabel,
          sortable: true,
          // searchable: true,
          // searchMethod: this.searchFileSize,
        },
        {
          label: '압축 용량',
          prop: 'compressSize',
          width: 100,
          formatter: this.getSizeLabel,
          sortable: true,
          // searchable: true,
          // searchMethod: this.searchCompSize,
        },
        {
          label: '압축률',
          prop: 'compressRate',
          width: 100,
          // sortable: true,
          // searchable: true,
          scopedSlot: 'compress-rate-slot',
        },
        {
          label: '보관 기한',
          prop: 'retentionAge',
          scopedSlot: 'retention-age-slot',
          width: 100,
          sortable: true,
          // searchable: true,
        },
        {
          label: '생성일',
          prop: 'registDatetime',
          scopedSlot: 'regist-datetime-slot',
          width: 160,
          searchable: true,
          searchType: 'date',
          sortable: true,
        },
        {
          label: '정합성 확인 시각',
          prop: 'hashChecktime',
          scopedSlot: 'coherence-slot',
          searchable: true,
          sortable: true,
          searchType: 'date',
          width: 160,
        },
        {
          label: '정합성',
          prop: 'hashIntegrityFlag',
          scopedSlot: 'hash-flag-slot',
          align: 'center',
          width: 60,
        },
        {
          label: '정합성 검사',
          scopedSlot: 'fileHash-slot',
          width: 110,
        },
      ],
      coherenceColor: {},
      selectedCollector: null,
      collectorSearchToolVisible: false,
      fileSearchToolVisible: false,
      isHashCheckLoading: false,
      hashCheckLoadingMsg: '파일 정합성을 확인하고 있습니다.',
      hashIntegrityFlag: {
        Y: 'NM',
        N: 'DN',
      },
      isDownloadLoading: false,
      downloadLoadingMsg: '파일을 다운로드 중입니다.',
      loadingMsg: '',
    };
  },
  computed: mapGetters(['eventlevelInfoWithNM']),
  watch: {
    activeTab: {
      immediate: true,
      handler() {
        if (this.activeTab === 'file') {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.coherenceColor = {
        green: this.eventlevelInfoWithNM.MN.eventlevelId,
        yellow: this.eventlevelInfoWithNM.MJ.eventlevelId,
        red: this.eventlevelInfoWithNM.DN.eventlevelId,
      };
    });
  },
  methods: {
    isNil,
    isEmpty,
    getValueAfterCheckEmpty,
    getDateToString,
    /**
     * 수집 서버 목록을 조회해온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      LogStoreAPI.getLogCollectors().then((response) => {
        if (response.data.success) {
          this.logCollectors = response.data.data;
          if (!isEmpty(this.logCollectors)) {
            this.$refs.collectorTable.$children[0].setCurrentRow(this.logCollectors[0]);
          }
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '수집 서버 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 선택한 수집 서버에 저장된 파일 목록을 조회해온다.
     * @author Minyeong
     * @param  {[type]} collector [description]
     * @return {[type]}           [description]
     */
    loadFileData(collector) {
      const params = {
        logCollectorId: collector.logCollectorId,
        ...this.tableParams,
      };
      this.loading = true;
      LogStoreAPI.getFilesByCollector(params).then((response) => {
        if (response.data.success) {
          this.logFiles = response.data.data;
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '파일', false));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '파일', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * 용량을 바이트 환산해 반환한다.
     * @author Minyeong
     * @param  {[type]} size [description]
     * @return {[type]}      [description]
     */
    getSizeLabel(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      const kbSize = value / 1024;
      if (kbSize <= 1024) {
        return `${Number.parseFloat(kbSize).toFixed(2)}KB`;
      }

      return `${convertValuByUnit(kbSize, 'KB', false, false, true)}B`;
    },
    /**
     * 압축 크기 검색
     * @author leesy918
     * @param  {[type]} value [description]
     * @param  {[type]} row   [description]
     * @return {[type]}       [description]
     */
    searchCompSize(value, row) {
      return this.searchSize(value, row, 'compressSize');
    },
    /**
     * 파일 크기 검색
     * @author Ju
     * @param  {[type]} value [description]
     * @param  {[type]} row   [description]
     * @return {[type]}       [description]
     */
    searchFileSize(value, row) {
      return this.searchSize(value, row, 'fileSize');
    },
    /**
     * 들어온 사이즈를 변환하여 비교한다 True이면 화면에 출력.
     * @author leesy918
     * @param  {[type]} value [description]
     * @param  {[type]} row   [description]
     * @param  {[type]} field [description]
     * @return {[type]}       [description]
     */
    searchSize(value, row, field) {
      const kbSize = row[field] / 1024;
      let calcSize;
      if (kbSize <= 1024) {
        calcSize = `${Number.parseFloat(kbSize).toFixed(2)}KB`;
      }
      calcSize = `${convertValuByUnit(kbSize, 'KB', false, false, true)}B`;
      return calcSize.indexOf(value) > -1;
    },
    /**
     * 파일의 용량과 압축 용량으로 압축률을 계산한다.
     * @author Minyeong
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    getCompressRate(item) {
      if (isNil(item)) {
        return EMPTY_TEXT;
      }
      return `${item}%`;
    },
    onChangeCollector(collector) {
      this.selectedCollector = collector;
      this.loadFileData(collector);
    },
    onToggleCollectorSearchTool() {
      this.collectorSearchToolVisible = !this.collectorSearchToolVisible;
    },
    onToggleFileSearchTool() {
      this.fileSearchToolVisible = !this.fileSearchToolVisible;
    },
    /**
     * 파일의 정합성 검사를 수행한다.
     * @author Minyeong
     * @param  {[type]} rawFile [description]
     * @return {[type]}         [description]
     */
    checkFileHash(rawFile) {
      const today = new Date();
      const fileRegistDate = new Date(rawFile.registDatetime);
      if (today.getFullYear() === fileRegistDate.getFullYear() && today.getMonth() === fileRegistDate.getMonth() && today.getDate() <= fileRegistDate.getDate()) {
        this.$message(msgUtils.getCustomMsgData('지난 파일만 정합성을 검사할 수 있습니다.'));
        return;
      }
      const params = {
        logId: rawFile.logId,
        fileId: rawFile.fileId,
      };
      this.isDownloadLoading = true;
      this.loadingMsg = this.hashCheckLoadingMsg;
      LogStoreAPI.performCheckFileHash(params).then((response) => {
        if (response.data.success) {
          const file = response.data.data;
          if (!isEmpty(file.fileHash) && file.runningStatus === 'R') {
            // 주기적으로 진행 상태 조회하는 함수 실행 (1초 간격)
            this.$taskManager.createTask(checkRunningStatusTask, 1, () => {
              LogStoreAPI.getHashCheckRunningStatus(params).then((res) => {
                const hashCheckedFile = res.data.data;
                if (res.data.success && !isEmpty(hashCheckedFile) && !isEmpty(hashCheckedFile.fileHash) && hashCheckedFile.runningStatus === 'F') {
                  this.$message(msgUtils.getCustomResultMsgData('파일 정합성 검사를 성공적으로 수행하였습니다.', true));
                  this.isDownloadLoading = false;
                  this.$taskManager.removeTask(checkRunningStatusTask);
                  this.loadFileData(this.selectedCollector);
                } else if (!res.data.success || isEmpty(hashCheckedFile) || isEmpty(hashCheckedFile.fileHash)) {
                  this.$message(msgUtils.getResultMsgData('정합성 검사', '파일', false));
                  this.$taskManager.removeTask(checkRunningStatusTask);
                  this.isDownloadLoading = false;
                }
              }).catch((e) => {
                this.$message(msgUtils.getResultMsgData('정합성 검사', '파일', false));
                throw new Error(e);
              });
            }, null, 10, () => {
              this.$message(msgUtils.getResultMsgData('정합성 검사', '파일', false));
              this.$taskManager.removeTask(checkRunningStatusTask);
              this.isDownloadLoading = false;
            });
            this.$taskManager.startTask(checkRunningStatusTask);
          } else {
            this.isDownloadLoading = false;
            this.$message(msgUtils.getCustomResultMsgData('파일 정합성 검사를 수행할 수 없는 상태입니다.', false));
          }
        } else {
          this.isDownloadLoading = false;
          this.$message(msgUtils.getResultMsgData('정합성 검사', '파일', false));
        }
      }).catch((e) => {
        this.$message(msgUtils.getCustomResultMsgData('파일 정합성 검사를 실패하였습니다.', false));
        throw new Error(e);
      });
    },
    /**
     * 로그 파일을 다운로드한다.
     * @author Minyeong
     * @param  {[type]} fileInfo [description]
     * @return {[type]}          [description]
     */
    downloadLogFile(fileInfo) {
      const today = new Date();
      const fileRegistDate = new Date(fileInfo.registDatetime);
      if (today.getFullYear() === fileRegistDate.getFullYear() && today.getMonth() === fileRegistDate.getMonth() && today.getDate() <= fileRegistDate.getDate()) {
        this.$message(msgUtils.getCustomMsgData('지난 파일만 다운로드할 수 있습니다.'));
        return;
      }
      const params = {
        logId: fileInfo.logId,
        fileId: fileInfo.fileId,
      };
      this.isDownloadLoading = true;
      this.loadingMsg = this.downloadLoadingMsg;
      LogStoreAPI.exportLogFile(params).then((response) => {
        if (response.data.success && !isNil(response.data.data)) {
          const form = document.createElement('form');
          form.action = `${baseUrl}/integrated-log/store/download-log-file.do`;
          form.method = 'post';
          const hiddenField = document.createElement('input');
          hiddenField.setAttribute('type', 'hidden');
          hiddenField.setAttribute('name', 'fileName');
          hiddenField.setAttribute('value', response.data.data);
          form.appendChild(hiddenField);
          document.body.appendChild(form);
          form.submit();

          document.body.removeChild(form);
          this.$message(msgUtils.getResultMsgData('다운로드', '파일', true));
          this.isDownloadLoading = false;
        } else {
          this.$message(msgUtils.getResultMsgData('다운로드', '파일', false));
          this.isDownloadLoading = false;
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.RUN, '파일 다운로드', false));
        throw new Error(e);
      });
    },
    /**
     * 테이블의 search condition 변경 이벤트 함수
     * @author Minyeong
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onConditionChange(value) {
      const params = cloneDeep(value);
      const searchParams = params.searchParams;
      const dateSearchParams = params.dateSearchParams;

      const tableParams = {
        start: params.start,
        limit: params.limit,
        sort: params.sort,
        dir: params.dir,
      };
      if (!isEmpty(searchParams)) {
        forEach(searchParams, (item) => {
          tableParams[item.field] = item.value;
        });
      }
      if (!isEmpty(dateSearchParams)) {
        forEach(dateSearchParams, (item) => {
          tableParams.datetimeType = item.field;
          tableParams.datetimeStart = new Date(item.start);
          tableParams.datetimeEnd = new Date(item.end);
        });
      }

      this.tableParams = tableParams;
      this.loadFileData(this.selectedCollector);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/popup/store/LogFileStore.vue